import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QuoteAPI } from '../constants/api.constants';
import { ResponseModel } from '../data/models/ResponseModel';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {

  constructor(private readonly http: HttpClient) { }

  addtoQuote(payload: any): Observable<any> {
    return this.http.post<any>(QuoteAPI.ADD_QUOTE_API, payload);
  }

  linkQuote(payload: any): Observable<any> {
    return this.http.post<any>(QuoteAPI.LINK_QUOTE_API, payload);
  }

  /** Resolve a DC quote's project/quote details (projectId, projectName, quoteId). */
  getQuoteDetails(quoteId: string): Observable<ResponseModel> {
    return this.http.get<any>(QuoteAPI.GET_QUOTE_DETAILS_API, {
      params: { quoteId }
    });
  }
}
